module.exports = __webpack_public_path__ + "static/media/Tawuniya-Regular.a5b1f28c.otf";